"use client";

/**
 * SetupHelpLink - the funnel's way to reach support where the chat launcher is hidden
 *
 * On /setup below 960 px the floating chat launcher is hidden (it sits on top of the step's primary
 * button, the pay button included: SetupClientProviders). This quiet line in normal flow, under the
 * step, opens the messenger instead, loading it on demand. Not shown from 960 px (launcher visible) or
 * on /app/setup (the dashboard keeps its own launcher).
 */
import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { T } from "gt-next";
import { openIntercomChat, SETUP_PATH } from "@/components/intercom/IntercomProvider";
export default function SetupHelpLink() {
  const $ = _c(1);
  const pathname = usePathname();
  if (!SETUP_PATH.test(pathname ?? "")) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="mt-4 text-center text-xs text-black/40 min-[960px]:hidden"><T>Need help?{" "}<button type="button" onClick={_temp} className="relative cursor-pointer underline underline-offset-2 transition-colors duration-150 after:absolute after:-inset-x-2 after:-inset-y-3.5 after:content-[''] hover:text-black/60 focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black/40">Chat with us</button></T></p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  return openIntercomChat();
}